import React, { Component } from 'react';
import styles from './styles.scss';
import qs from "query-string";
import WJSON from '../../helpers/json';
class CreditView extends Component 
{
  constructor(props){
    super(props);

    let item = {}

    let query = qs.parse(props.location.search);
    
    if (query.item)
    {
      item = WJSON.decode(query.item)
    }

    this.state = { item : item };

  }
  componentDidMount(){

  }
  render()
  {

    return (
      <div className={styles.page_container}>
        <div className={styles.padding_container}>
          <div className={styles.title_area}>
            <div className={styles.page_title}>
              登入帳號=戶別+樓層+卡片序號
            </div>
          </div>
          <div className={styles.content_area}>
          <span className={styles.label_title}>地址範例&帳號組成規則：</span>
            <div className={styles.text_item}>
              <div className={[styles.text, styles.center].join(' ')}>新北市林口鄉文化二路1段</div>
              <div className={[styles.text, styles.center].join(' ')}>
                <span className="red arrow"> 300 </span>號 
                <span className="red arrow"> 5 </span>樓
              </div>
              <div className={[styles.text, styles.red, styles.comment].join(' ')}>A02(戶別)+05(樓)+流水號</div>
            </div>
            <div className={styles.text_item}>
              <span className={styles.label_title} style={{marginTop: '20px'}}>相關名詞說明：</span>
              <div className={styles.text}>
                <ul>
                  <li>
                    <span className="bold">戶別：</span>假設您居住的社區300號戶別為A02，則請帶入戶別對應的英數字，如不確定請洽物管查詢。
                  </li>
                  <li>
                    <span className="bold">
                      樓層：
                    </span>
                    與地址所在樓層相同，最多2碼，格式為00，1樓為01，2樓為02…</li>
                  <li><span className="bold">流水號：</span>屋主為001，系統會自動轉換，可不輸入，第二張卡片後以002,003編碼</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreditView;


// WEBPACK FOOTER //
// ./src/views/Forgot/ForgotAccount.js